import React from 'react';
import Moment from 'react-moment';

import moment from 'moment';
import 'moment/locale/es';
import 'moment-timezone';

Moment.globalMoment = moment;
Moment.globalLocale = 'es';
Moment.globalTimezone = 'America/Mexico_City';


const formatoModena = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
});

//const opcionesFecha = { timeZone: 'America/Mexico_City', weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric", hour12: "false" };
const servicioFormatos = {

  formatearModena(valor) {
    if (null === valor || undefined === valor) {
      return null;
    }else{
      return formatoModena.format(valor);
    }
    
  },

  formatearFecha(valor) {
    if (null === valor || undefined === valor) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="YYYY-MM-DD HH:mm:ss"></Moment>

    }
  },

  formatearFechaSinSegundos(valor) {
    if (null === valor || undefined === valor) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="YYYY-MMMM-DD"></Moment>;
    }
  },
  formatearFechaString(valor) {
    if(null===valor || undefined===valor){
      return null;
    } else{
      let fecha = moment(valor).format('YYYY-MM-DD HH:mm:ss');
      return fecha;
    }       
  },
  formatearFechaStringSinSegundos(valor) {
    if(null===valor || undefined===valor){
      return null;
    } else{
      let fecha = moment(valor).format('YYYY-MM-DD');
      return fecha;
    }       
  },
  formatearFechaYYYYMMDDHHmmss(valor) {
    if (null === valor || undefined === valor) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="YYYY-MMMM-DD HH:mm:ss a"></Moment>;
    }      
  },
  redondearNumeroDosDecimales(num) {
    return Math.round(num * 100) / 100;
  }
  ,
  redondearNumeroSeisDecimales(numero) {
    const factorDeMultiplicacion = 1e6;
  const numeroFormateado = Math.round(numero * factorDeMultiplicacion) / factorDeMultiplicacion;
  return numeroFormateado.toString();
  },

  formatoEstadoCfdi(estado) {
    if (estado === 0)
      return <p>Generado</p>;
    if (estado === 1)
      return <p>Activo</p>;
    if (estado === 2)
      return <p>Cancelado</p>;
  }
}


export default servicioFormatos;